import styled from 'styled-components'

import Modal from 'components/Modal'
import Button from 'components/Button'
import { CrossBigIcon } from 'icons'
import copy from 'copy.json'

type Props = {
  isModalOpen: boolean
  onModalClose: () => void
  onModalConfirmation: () => void
}

const text = copy.page.matches.modal.no_matching_offers
const button = copy.common.button

export default function NoMatchingOffersModal({
  isModalOpen,
  onModalClose,
  onModalConfirmation
}: Props) {
  return (
    <StyledModal isOpen={isModalOpen} onClose={onModalClose}>
      <CrossBigIcon />
      <h3>{text.title}</h3>
      <p>{text.description}</p>

      <div className="buttons">
        <Button onClick={onModalConfirmation} secondary style={{ border: 'none' }}>
          {text.button}
        </Button>

        <Button tertiary onClick={onModalClose}>
          {button.close}
        </Button>
      </div>
    </StyledModal>
  )
}

const StyledModal = styled(Modal)`
  max-width: 644px;
  width: 100%;

  background: var(--orange);
  color: var(--white);

  h3 {
    font: var(--600-24);
  }

  .buttons {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    max-width: 312px;
    margin-bottom: 24px;
  }

  svg {
    stroke: var(--white);
  }
`
